// Pre Booking API
import queryString from 'query-string'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    PreBookingReasonForChange,
} from 'app/enums/label.enums'
import {
    PreBookingEntity,
} from 'app/Apps/PreBooking/PreBooking.types'

type PrebookingRequests = {
    filterRequest: RequestConfigFunction<Record<string, any>>,
    filterRequestForBulkEdit: RequestConfigFunction<Record<string, any>>,
    get: RequestConfigFunction<{ id: number }>,
    bulkCreate: RequestConfigFunction<{ data?: PreBookingEntity[] }>,
    bulkEdit: RequestConfigFunction<{ data?: PreBookingEntity[] }>,
    getPrebookingByParams: RequestConfigFunction<{ mawb?: string }>,
    create: RequestConfigFunction<{ data: PreBookingEntity }>,
    update: RequestConfigFunction<{
        id: number,
        data: PreBookingEntity,
        reason: PreBookingReasonForChange,
    }>,
    modifications: RequestConfigFunction<{ id: number }>,
    getRequiredContainersChanges: RequestConfigFunction<{ id: number }>,
    reviewWithCustomerNeeded: RequestConfigFunction,
    openWithBookingFilterRequest: RequestConfigFunction<Record<string, any>>,
    // Comment methods
    filterComments: RequestConfigFunction<{
        id: string,
        params?: Record<string, any>,
    }>,
    createComment: RequestConfigFunction<{ id: number }>,
    deleteComment: RequestConfigFunction<{ id: number }>,
    filterRequestContainerAvailabilityAssessment: RequestConfigFunction<{
        params?: Record<string, any>,
    }>,
    filterRequestContainerAvailabilityAssessmentCount: RequestConfigFunction<{
        fieldName: string,
        params?: Record<string, any>,
    }>,
}

const preBookingRequests: PrebookingRequests = {
    filterRequest: ({
        params,
    }) => {
        return {
            url: 'prebooking/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    filterRequestForBulkEdit: (params) => {
        return {
            url: 'prebooking/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `prebooking/${id}`,
            method: 'GET',
        }
    },
    bulkCreate: ({
        data,
    } = {}) => {
        return {
            url: 'prebooking/bulk',
            method: 'POST',
            data,
        }
    },
    bulkEdit: ({
        data,
    } = {}) => {
        return {
            url: 'prebooking/data/bulk',
            method: 'PATCH',
            data,
        }
    },
    getPrebookingByParams: ({
        mawb,
    }) => {
        return {
            url: queryString.stringifyUrl({
                url: 'prebooking',
                query: {
                    mawb,
                },
            }),
            method: 'GET',
        }
    },
    create: ({
        data,
    }) => {
        return {
            url: 'prebooking',
            method: 'POST',
            data,
        }
    },
    update: ({
        id,
        data,
        reason,
    }) => {
        return {
            url: `prebooking/${id}?modificationReason=${reason}`,
            method: 'PUT',
            data,
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `prebooking/${id}/modifications`,
            method: 'GET',
        }
    },
    getRequiredContainersChanges: ({
        id,
    }) => {
        return {
            url: `prebooking/${id}/requiredcontainerschanges/all`,
            method: 'GET',
        }
    },
    reviewWithCustomerNeeded: () => {
        return {
            url: 'prebooking/filter-request/review-with-customer-needed',
            method: 'GET',
        }
    },
    // Comment methods
    filterComments: ({
        id,
        params = {},
    }) => {
        return {
            url: `prebooking/${id}/comment/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    createComment: ({
        id,
    }) => {
        return {
            url: `prebooking/${id}/comment`,
            method: 'POST',
        }
    },
    deleteComment: ({
        id,
    }) => {
        return {
            url: `prebooking/comment/${id}/archive`,
            method: 'PATCH',
        }
    },
    openWithBookingFilterRequest: (params = {}) => {
        return {
            url: 'prebooking/filter-request/open-with-booking',
            method: 'POST',
            ...params,
        }
    },
    filterRequestContainerAvailabilityAssessment: ({
        params = {},
    } = {}) => {
        return {
            url: 'prebooking/filter-request/container-availability-assessment',
            method: 'POST',
            ...params,
        }
    },
    filterRequestContainerAvailabilityAssessmentCount: ({
        fieldName,
        params = {},
    }) => {
        return {
            url: `prebooking/filter-request/container-availability-assessment/count/${fieldName}`,
            method: 'POST',
            ...params,
        }
    },
}

export default preBookingRequests
